import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, DatoEntity } from '../../../../services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-casilla-verificacion',
  templateUrl: './casilla-verificacion.component.html',
  styleUrls: ['./casilla-verificacion.component.css']
})
export class CasillaVerificacionComponent implements OnInit {

  @Input() nodo: NodoEntity;

  titulo: string;
  options: NodoEntity[] = [];

  constructor() { }

  ngOnInit() {
    // console.log('** Componente Casilla Verificacion', this.nodo);
    if (this.nodo) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    if (this.nodo.hijos) {
      this.options = this.nodo.hijos;
    }
  }

  isChecked(option: NodoEntity): boolean {
    if (this.nodo.datos && this.nodo.datos.length > 0) {
      const dato = this.nodo.datos.find((d: DatoEntity) => d.valor.includes(String(option.id)));
      return dato ? true : false;
    }

    return false;
  }

}
